import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.mitteilung-loeschen';
import * as api from '../../../clients/kommunikation';

@Injectable()
export class KommunikationMitteilungLoeschenEffects {

    MitteilungLoeschen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_MITTEILUNG_LOESCHEN),
        mergeMap((x: ac.PostMitteilungLoeschenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postMitteilungLoeschen(x.mitteilungLoeschenRequest).pipe(
                map((result: any) => {
                    return new ac.PostMitteilungLoeschenErfolgreichAction(result, x.mitteilungLoeschenRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostMitteilungLoeschenFehlerAction(error, x.mitteilungLoeschenRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.MitteilungenCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.MitteilungenCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.MitteilungenCommandService);
        }
        return this.service;
    }
}
